export enum FormFieldTypes {
  SECTION = "section",
  TEXT = "text",
  DROPDOWN = "dropdown",
  DATE = "date",
  GROUP = "group",
  ACTION = "action",
  RADIO = "radio",
  AUTOSELECT = "autoselect",
  ARRAY = "array",
}
